import React, { useState } from "react";
import moment from "moment";
import { NavLink } from "react-router-dom";

const Row = ({ i }) => {
  const [expandedInventory, setExpandedInventory] = useState({ id: 0 });

  const handleExpand = (inventory) => {
    setExpandedInventory((prev) =>
      prev.id === inventory.id ? { id: 0 } : inventory
    );
  };

  return (
    <React.Fragment key={i.id}>
      <tr>
        <td>
          <NavLink to={`/inventory/${i.id}/`}>{i.id}</NavLink>
        </td>
        <td className="hidden-md-down">{i.item_name}</td>
        <td className="hidden-xs-down">{parseFloat(i.weight.toFixed(2))}</td>
        <td>
          <NavLink to={`/shipment/${i.shipment_id}/`}>{i.shipment_id}</NavLink>
        </td>
        <td className="hidden-xs-down">
          {i.shipment_creation_date
            ? moment(i.shipment_creation_date).format("L")
            : ""}
        </td>
        <td className="hidden-md-down">{i.shipment_id ? i.current_location_name : null}</td>
        <td>
          <NavLink to={`/session/${i.session_product_id}/`}>
            {i.session_product_id}
          </NavLink>
        </td>
        <td
          title={
            expandedInventory.id === i.id ? "Contract items" : "Expand items"
          }
        >
          <div className="d-flex">
            <button
              disabled={
                i.leftover_items.length === 0 && i.product_items.length === 0
              }
              className="btn btn-primary color-white mr-0"
              style={{
                lineHeight: ".05",
                fontSize: "0.875rem",
                padding: "0.2rem 0.5rem",
              }}
              onClick={() => handleExpand(i)}
            >
              <i
                className={`fa ${
                  expandedInventory.id === i.id ? "fa-compress" : "fa-expand"
                }`}
              ></i>
            </button>
          </div>
        </td>
      </tr>
      {expandedInventory.id === i.id && (
        <>
          {i.product_items.length > 0 && (
            <>
              <tr>
                <td colSpan="8" style={{ backgroundColor: "#dedede" }}>
                  <div>
                    {/* Add any extra information here for the expanded state */}
                    Expanded product_items for inventory {i.item_name} ID {i.id}
                  </div>
                </td>
              </tr>
              {i.product_items.map((i) => (
                <Row key={i.id} i={i} />
              ))}
            </>
          )}
          {i.leftover_items.length > 0 && (
            <>
              <tr>
                <td colSpan="8" style={{ backgroundColor: "#dedede" }}>
                  <div>
                    {/* Add any extra information here for the expanded state */}
                    Expanded leftover_items for inventory {i.item_name} ID {i.id}
                  </div>
                </td>
              </tr>
              {i.leftover_items.map((i) => (
                <Row key={i.id} i={i} />
              ))}
            </>
          )}
          <tr>
            <td
              colSpan="8"
              style={{ padding: "5px", backgroundColor: "#7f7f7f" }}
            >
              <div></div>
            </td>
          </tr>
        </>
      )}
    </React.Fragment>
  );
};

const ReportRecall = ({ inventoriesList, noFilters }) => {
  return (
    <div className="card p-0">
      <table className="table table-striped table-bordered datatable mb-0">
        <thead>
          <tr>
            <th>Inventory ID</th>
            <th className="hidden-md-down">Item name</th>
            <th className="hidden-xs-down">Quantity</th>
            <th className="hidden-xs-down">Shipment ID</th>
            <th className="hidden-md-down">Shipped date</th>
            <th className="hidden-xs-down">Location</th>
            <th className="hidden-xs-down">Prod. session ID</th>
            <th>Actions</th>
          </tr>
        </thead>

        {inventoriesList.length ? (
          <tbody>
            {inventoriesList.map((i) => (
              <Row key={i.id} i={i} />
            ))}
          </tbody>
        ) : (
          <tbody>
            <tr>
              <td colSpan="8" className="text-center">
                {noFilters && inventoriesList.length === 0 ?'Change the filters to search for inventories' :  'No results for given filters'}
              </td>
            </tr>
          </tbody>
        )}
      </table>
    </div>
  );
};

export default ReportRecall;
